<template>
    <div class="top-navbar">
        <base-nav
            container-classes="container-fluid"
            class="navbar-top border-bottom navbar-expand bg-info navbar-dark"
            :class="themeClass"
        >

            <!-- Breadcrumb -->
            <breadcrumb
                :list-classes="'breadcrumb-dark bg-info pl-0 mb-0 '+themeClass"
                v-if="breadcrumb"
            >
                <breadcrumb-item>
                    <router-link to="/socrates/ui/home">
                        <i class="fas fa-home mr-2"></i>
                    </router-link>
                </breadcrumb-item>
                <breadcrumb-item v-for="(item, index) in breadcrumb" :key="index" :active="!item.route">
                    <router-link :to="item.route" v-if="item.route">
                        {{ item.name }}
                    </router-link>
                    <span v-else>
                        {{ item.name }}
                    </span>
                </breadcrumb-item>
            </breadcrumb>

            <!-- Navbar links -->
            <ul class="navbar-nav align-items-center ml-auto">
                <li class="nav-item d-xl-none" v-if="$permissions.sidebar()">

                    <!-- Sidenav toggler -->
                    <div class="pr-3 sidenav-toggler sidenav-toggler-dark"
                        :class="{active: $sidebar.showSidebar}"
                        @click="toggleSidebar">
                        <div class="sidenav-toggler-inner" id="sidenav-toggler">
                            <i class="sidenav-toggler-line"></i>
                            <i class="sidenav-toggler-line"></i>
                            <i class="sidenav-toggler-line"></i>
                        </div>
                    </div>
                </li>
            </ul>
            <ul class="navbar-nav align-items-center ml-0">
                <base-dropdown menu-on-right
                        class="nav-item"
                        tag="li"
                        title-tag="a"
                        title-classes="nav-link pr-0">
                    <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
                        <div class="media align-items-center">
                            <span class="status-bullet text-danger mr-1" v-if="$auth.offline">
                                <i class="fas fa-circle"></i>
                            </span>
                            <span class="avatar avatar-sm rounded-circle">
                                <img :src="$auth.user.avatar">
                            </span>
                            <div class="media-body ml-2 d-none d-lg-block">
                                <span class="mb-0 text-sm font-weight-bold">{{ $auth.user.name }}</span>
                            </div>
                        </div>
                    </a>

                    <template>
                        <a href="#" class="dropdown-item" @click.prevent="offlineDashboard"
                            v-if="$permissions.offlineDashboard()"
                        >
                            <i class="tim-icons icon-plug-2"></i>
                            <span>{{ $t('pwa.dashboard') }}</span>
                        </a>
                        <a href="#" class="dropdown-item" @click.prevent="myAccount" v-if="!$auth.offline">
                            <i class="tim-icons icon-single-02"></i>
                            <span>{{ $t('auth.my-account') }}</span>
                        </a>
                        <a href="#" class="dropdown-item" @click.prevent="privacy" v-if="!$auth.offline">
                            <i class="tim-icons icon-c-info"></i>
                            <span>{{ $t('common.privacy') }}</span>
                        </a>
                        <div class="dropdown-divider" v-if="!$auth.offline"></div>
                        <logout-link v-if="!$auth.offline"></logout-link>
                    </template>

                </base-dropdown>
            </ul>
        </base-nav>
        <base-header type="info" :class="'pb-'+padding+' '+themeClass"></base-header>
    </div>
</template>

<script>
    import { CollapseTransition } from 'vue2-transitions';
    import LogoutLink from './LogoutLink';

    export default {

        components: {
            CollapseTransition,
            LogoutLink
        },

        props: {

            breadcrumb: {
                type: Array,
                default: null
            },

            padding: {
                type: Number,
                default: 6
            }
        },
        
        computed: {
            themeClass() {
                return 'bg-socrates-' + window.socratesTheme
            }
        },

        methods: {
            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
            toggleSidebar() {
                this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
            },
            myAccount() {
                this.$router.push({ name: 'my-account' });
            },
            privacy() {
                this.$router.push({ name: 'privacy' });
            },
            offlineDashboard() {
                this.$router.push({ name: 'offline-dashboard' });
            }
        }
    };
</script>

<style scoped>

    .top-navbar >>> .breadcrumb-item {
        font-size: 0.95rem;
    }
    .top-navbar >>> .breadcrumb-item + .breadcrumb-item::before {
        color: #dee2e6 !important;
        content: ">";
    }
    .status-bullet {
        font-size: 8px;
    }

</style>